import React from 'react';

import { graphql, StaticQuery } from 'gatsby';
import slugify from 'slugify';

import CategoryFilterList from './category-filter-list';

class CategoryFilterSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.bookSubcategoryFilterList = this.bookSubcategoryFilterList.bind(this);
    this.printArtistFilterList = this.printArtistFilterList.bind(this);
    this.printCenturyFilterList = this.printCenturyFilterList.bind(this);
    this.printMediumFilterList = this.printMediumFilterList.bind(this);
  }

  prepareLinksList(edges, dataField) {
    let preparedEdges = edges;

    if (dataField === 'Century') {
      const centuryOrder = [
        "13th century",
        "14th century",
        "15th century",
        "16th century",
        "17th century",
        "18th century",
        "19th century",
        "20th century",
        "21st century",
      ];

      preparedEdges = preparedEdges.sort((a, b) => {
        const idxA = centuryOrder.indexOf(a.node.data.Century[0]);
        const idxB = centuryOrder.indexOf(b.node.data.Century[0]);

        if (idxB < idxA) {
          return 1;
        } else if (idxB > idxA) {
          return -1;
        }

        return 0;
      })
    }

    let links = preparedEdges.map(({ node }) => node.data[dataField]);
    links = [].concat(...links);
    links = links.filter((val, idx, self) => self.indexOf(val) === idx);
    links = links.filter(val => val !== null);

    links = links.map(link => {
      const matchedPrints = preparedEdges.filter(({ node }) => {
        if (node.data[dataField] instanceof Array) {
          return node.data[dataField].includes(link);
        } else if (typeof node.data[dataField] === 'string' ||
                   node.data[dataField] instanceof String) {
          return node.data[dataField] === link;
        }

        return false;
      });

      return {
        label: link,
        slug: slugify(link.toLowerCase()),
        count: matchedPrints.length,
      };
    });

    if (dataField !== 'Century') {
      links.sort((a, b) => {
        if (b.count > a.count) {
          return 1;
        } else if (b.count < a.count) {
          return -1;
        }

        return 0;
      });
    }

    return links;
  }

  bookSubcategoryFilterList(edges) {
    const links = this.prepareLinksList(edges, 'Subcategory');

    return (
      <CategoryFilterList
        listHeader="Sub-Category"
        pathStem="pdr-press-books"
        links={links}
      />
    );
  }

  otherProductsFilterList(edges) {
    const shirtCount = edges.filter(({ node }) => node.table === 'Shirts').length;
    const mugCount = edges.filter(({ node }) => node.data.Category === 'Mugs').length;
    const toteCount = edges.filter(({ node }) => node.data.Category === 'Totes').length;
    let links = [
      {
        label: "T-Shirts",
        slug: "t-shirts",
        count: shirtCount,
      },
      {
        label: "Mugs",
        slug: "mugs",
        count: mugCount,
      },
      {
        label: "Tote Bags",
        slug: "totes",
        count: toteCount,
      },
    ];
    links = links.sort((a, b) => a.count < b.count);

    return (
      <CategoryFilterList
        listHeader="Sub-Category"
        pathStem=""
        links={links}
      />
    );
  }

  printArtistFilterList(edges) {
    const links = this.prepareLinksList(edges, 'Artist');

    return (
      <CategoryFilterList
        listHeader="Artist"
        pathStem="fine-art-prints/artist"
        links={links}
        sortSlug={this.props.sortSlug}
      />
    );
  }

  printCenturyFilterList(edges) {
    const links = this.prepareLinksList(edges, 'Century');

    return (
      <CategoryFilterList
        listHeader="Century"
        pathStem="fine-art-prints/century"
        links={links}
        sortSlug={this.props.sortSlug}
      />
    );
  }

  printMediumFilterList(edges) {
    const links = this.prepareLinksList(edges, 'Style');

    return (
      <CategoryFilterList
        listHeader="Medium"
        pathStem="fine-art-prints/style"
        links={links}
        sortSlug={this.props.sortSlug}
      />
    );
  }

  printSubjectFilterList(edges) {
    const links = this.prepareLinksList(edges, 'Subject');

    return (
      <CategoryFilterList
        listHeader="Subject"
        pathStem="fine-art-prints/subject"
        links={links}
        sortSlug={this.props.sortSlug}
      />
    );
  }

  render() {
    const query = graphql`
    {
      prints: allAirtable(filter: {table: {eq: "Prints"}, data: {Published: {eq: true}}}) {
        edges {
          node {
            data {
              Artist
              Sorted_Artist
              Century
              Place
              Style
              Subject
            }
          }
        }
      }
      books: allAirtable(filter: {table: {eq: "Simple"}, data: {Category: {eq: "Books"}, Published: {eq: true}}}) {
        edges {
          node {
            data {
              Subcategory
            }
          }
        }
      }
      hardgoods: allAirtable(filter: {table: {in: ["Simple", "Shirts"]},
                                      data: {Category: {in: ["Mugs", "Totes", null]}, Published: {eq: true}}}) {
        edges {
          node {
            table
            data {
              Category
            }
          }
        }
      }
    }
    `;

    return (
      <StaticQuery
        query={query}
        render={data => (
          <>
            {(this.props.categorySlug === 'fine-art-prints') ? (
              <>
                {this.printArtistFilterList(data.prints.edges)}
                {this.printCenturyFilterList(data.prints.edges)}
                {this.printSubjectFilterList(data.prints.edges)}
                {this.printMediumFilterList(data.prints.edges)}
              </>
            ) : null}
            {(this.props.categorySlug === 'pdr-press-books') ? (
              <>
                {this.bookSubcategoryFilterList(data.books.edges)}
              </>
            ) : null}
            {(['t-shirts', 'mugs', 'totes', 't-shirts-mugs'].includes(this.props.categorySlug)) ? (
              <>
                {this.otherProductsFilterList(data.hardgoods.edges)}
              </>
            ) : null}
          </>
        )}
      />
    );
  }
}

export default CategoryFilterSidebar;
